import styled from 'styled-components';
import { DESKTOP_WIDTH, TABLET_WIDTH, MOBILE_WIDTH } from '../globalUtils';
import { Area, Title, RedStripe } from './index.style';

import { ReactComponent as ArrowSVG } from '../../icons/Arrow.svg'

export const TopText = styled.div`
    color: #003a70;
    font-size: 18px;
    margin-bottom: 51px;
`;

export const PackagesHolder = styled.div`
    display: flex;
    height: 533px;
    width: 1024px;
    border: 3px solid rgb(0, 58, 112);
    border-radius: 70px 20px 0 0;
    overflow: hidden;
    margin-bottom: 171px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        display: none;
    }
`;

export const SliderPackagesHolder = styled.div`
    display: none;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        width: 100%;
        display: initial;
        margin-bottom: 52px;
    }
`;

export const PackageHolder = styled.div`
    display: flex;
    flex-direction: column;
    width: 256px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        margin-left: 50px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        margin-left: 33px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        margin-left: 15px;
    }
`;

export const TopPart = styled.div`
    height: 228px;
    background-color: #003a70;
    display: flex;
    flex-direction: column;
    justify-content: start;
    border-left: ${({ last }) => last ? 0 : 1}px solid #fff;
    align-items: center;
`;

export const TopPartTitle = styled.div`
    color: #ffffff;
    text-align: center;
    font-size: 22px;
    font-weight: 600;
    margin: 35px 0 38px;
`;

export const TopPartText = styled.div`
    color: #ffffff;
    text-align: center;
    font-size: 16px;
    width: 237px;
`;

export const BottomPart = styled.div`
    display: flex;
    flex-direction: column;
    border-left: ${({ last }) => last ? 0 : 1}px solid #003a70;
    flex: 1 1 auto;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        border: 1px solid #003a70;
        padding-bottom: 22px;
        border-top: 0;
        width: 253px;
        margin-left: 1px;
    }
`;

export const Insurance = styled.div`
    color: #003a70;
    text-align: center;
    font-size: 18px;
    height: 161px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 37px 0 38px;
`;

export const NoWrap = styled.span`
    white-space: nowrap;
`;

export const RedBold = styled.span`
    color: #ff4438;
    text-align: center;
    font-weight: 600;
`;

export const InsuranceCTA = styled.div`
    cursor: pointer;
    height: 36px;
    width: 195px;
    background-color: #ff4438;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    color: #f1efef;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    font-size: 20px; 
`;

export const Arrow = styled(ArrowSVG)`
    fill: #ff4438;
    height: 17px!important;
    width: 10px!important;
`;

export { Area, Title, RedStripe };